import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { modules } from '../../constants';
import { produce } from 'immer';
import { useSearchStore } from '../store';

const initialState = {
    searchResults: [],
    prevSelectedMls: null,
};

let searchResultsStore = (set) => ({
    [modules.proficiencyMetrics.suggestedAgents]: initialState,
    [modules.proficiencyMetrics.agentMovement]: initialState,
    [modules.proficiencyMetrics.savedAgents]: initialState,
    setSearchResults: (data) => set(produce(state => {
        const selectedModule = useSearchStore.getState().selectedModule;
        state[selectedModule].searchResults = data;
    })),
    setSavedAgentsSearchResults: (data) => set(produce(state => {
        const selectedModule = useSearchStore.getState().selectedModule;
        state[selectedModule].searchResults = data;
    })),
    setPrevSelectedMls: (mlsId) => set(produce(state => {
        const selectedModule = useSearchStore.getState().selectedModule;
        state[selectedModule].prevSelectedMls = mlsId;
    })),
    resetSavedAgentsSearchResults: () => set(produce(state => {
        const selectedModule = useSearchStore.getState().selectedModule;
        state[selectedModule].searchResults = [];
    })),
});

export const useSearchResultsStore = create(
    devtools(
        searchResultsStore,
        {
            name: 'search_results_state',
        }
    )
);
